/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module DriverinstallTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Driverinstall {
    [k: string]: any;
}
/**
 * Driver package details.
 *
 * This interface was referenced by `Driverinstall`'s JSON-Schema
 * via the `definition` "Package".
 */
export interface Package {
    id: string;
    title: string;
    version: string;
    currentVersion: string;
    resultText: string;
    resultCode: number;
    selectedForInstall: boolean;
    critical: boolean;
}
/**
 * Installer state used for exchanging information with plugin.
 *
 * This interface was referenced by `Driverinstall`'s JSON-Schema
 * via the `definition` "InstallerState".
 */
export interface InstallerState {
    method: MethodEnum;
    form: FormEnum;
    nextAction?: NextActionEnum;
    errorCode?: number;
    packages?: Package[];
    cleanInstall?: boolean;
    constraintFailText?: string[];
    failedConstraintId?: string[];
}
/**
 * Installation progress
 *
 * This interface was referenced by `Driverinstall`'s JSON-Schema
 * via the `definition` "Progress".
 */
export interface Progress {
    method: MethodEnum;
    form: FormEnum;
    progressTitle: string;
    currentProgress: number;
    totalProgress: number;
}
/**
 * This interface was referenced by `Driverinstall`'s JSON-Schema
 * via the `definition` "InstallAsyncParameters".
 */
export interface InstallAsyncParameters {
    driverLocation: string;
    isCustom: boolean;
    resumeInstall: boolean;
}

/**
 * This interface was referenced by `Driverinstall`'s JSON-Schema
 * via the `definition` "ErrorCodeEnum".
 */
export enum ErrorCodeEnum {
    NoError = 0,
    GeneralError = -505409537,
    InvalidObject = -505413631,
    InsufficientArguments = -505413630,
    InvalidParameters = -505413629,
    PropertyMissing = -505413628,
    InvalidFormat = -505413627,
    EmptyValue = -505413626,
    FileNotFound = -505413622,
    PathNotFound = -505413621,
    ProcessingPreviousCall = 505413620,
    InstallerAlreadyRunning = -505413619,
    MessagingChannel = -505413618,
    ExtractedNotFound = -505413610,
    InstallerExeNotFound = -505413608,
    GfeExperienceKeyNotFound = -505413607,
    GfeExperiencePathEmpty = -505413606,
    SignatureInvalid = -505413605,
    UacCancelled = -505413600,
    MsgArrivedEventCreate = -505413599,
    MsgArrivedEventSignal = -505413598,
    ResumePathNotFound = -505413597,
    ResumePathEmpty = -505413596,
    ResumePathInvalid = -505413595,
    MsgChannelInit = -505413584,
    MsgShowFormSet = -505413583,
    MsgProgressUpdateSet = -505413582,
    MsgListen = -505413581
}
/**
 * This interface was referenced by `Driverinstall`'s JSON-Schema
 * via the `definition` "MethodEnum".
 */
export enum MethodEnum {
    NotSet = 0,
    ShowForm = 1,
    ProgressUpdate = 2
}
/**
 * This interface was referenced by `Driverinstall`'s JSON-Schema
 * via the `definition` "FormEnum".
 */
export enum FormEnum {
    NotSet = 0,
    InstallInitial = 1,
    InstallChecking = 2,
    InstallCheckWarnings = 3,
    InstallCheckFailed = 4,
    InstallCheckWait = 5,
    Eula = 6,
    InstallSelect = 7,
    InstallSelectCustom = 8,
    InstallSelectInstallPath = 9,
    PreInstallCheck = 10,
    PreInstallCheckRetry = 11,
    PreInstallCheckWait = 12,
    PreRebootInstall = 13,
    PackageDownloadProgress = 14,
    ProcessDownloadedPackage = 15,
    PackageDownloadFailed = 16,
    InstallProgress = 17,
    InstallRemoveProgress = 18,
    InstallFinished = 19,
    InstallFinishedNoSummary = 20,
    InstallFinishedLaunch = 21,
    InstallFinishedNoSummaryLaunch = 22,
    InstallFinishedOptions = 23,
    InstallFinishedNoSummaryOptions = 24,
    InstallReboot = 25,
    InstallRebootOptions = 26,
    InstallRebootNoSummary = 27,
    InstallRebootNoSummaryOptions = 28,
    InstallRemoveReboot = 29,
    InstallFailed = 30,
    WaitingOnUac = 31
}
/**
 * This interface was referenced by `Driverinstall`'s JSON-Schema
 * via the `definition` "NextActionEnum".
 */
export enum NextActionEnum {
    Next = 0,
    Close = 1
}


}
